import React from 'react';
import { multilingualSpeakable } from '../utils/multilingualSEO';

/**
 * Renders hidden multilingual speakable content for voice search.
 * Each language block is tagged with lang attribute for search engines.
 * Content is sr-only (screen reader only) — invisible to users.
 */
const MultilingualSpeakable = ({ pageKey }) => {
  const languages = { fr: "French", de: "German", it: "Italian", nl: "Dutch", es: "Spanish", ro: "Romanian" };

  return (
    <div className="sr-only" aria-hidden="false" data-testid={`multilingual-speakable-${pageKey}`}>
      {Object.entries(languages).map(([code]) => {
        const content = multilingualSpeakable[code]?.[pageKey];
        if (!content) return null;
        return (
          <div key={code} lang={code} className="speakable-answer">
            {content.map((text, i) => (
              <p key={i}>{text}</p>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default MultilingualSpeakable;
